import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';

import { useAsset } from '@ocx/data-configuration';
import { Typography, SizingMultiplier, Paper } from '@ocx/ui';

type StoreAddressProps = {
  children: ReactNode;
};

export const StoreAddress = ({ children }: StoreAddressProps) => {
  const mapMarkerSrc = useAsset('MapMarker');

  return (
    <Stack
      component={Paper}
      direction="row"
      alignItems="center"
      spacing={SizingMultiplier.sm}
      px={1.5}
      borderRadius={(theme) => theme.spacing(SizingMultiplier.sm)}
      outlined>
      <Box component="img" src={mapMarkerSrc} alt="marker" height={24} mr={SizingMultiplier.sm} />
      <Typography variant="caption">{children}</Typography>
    </Stack>
  );
};
